<div class="card">
  <div class="card-body">
    <div class="flex flex-col items-center">
      <div class="value">{{ cardValue }}</div>
      <label class="content">{{ cardContent }}</label>
    </div>
  </div>
</div>
